"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CreateUpdateFolder {
    static getAttributeTypeMap() {
        return CreateUpdateFolder.attributeTypeMap;
    }
}
CreateUpdateFolder.discriminator = undefined;
CreateUpdateFolder.attributeTypeMap = [
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    }
];
exports.CreateUpdateFolder = CreateUpdateFolder;
//# sourceMappingURL=createUpdateFolder.js.map